import { COMPONENT_VIEW } from "../constants/typeConstants";
import common from "./common";
/**
 * factory function to produce Divider Component Object
 * @param {String} name
 * @param {Array} children array
 */
export default function(name = "Divider", children = []) {
  let obj = {
    name: name,
    type: COMPONENT_VIEW,
    children: children
  };
  return Object.assign(obj, common);
}
